import styled from "@emotion/styled";
import { Spacing } from "@snapchat/snap-design-system";

export const SpectaclesTagsContainer = styled.div`
    margin-top: ${Spacing.MD}px;
`;
